import { render } from "./PersonalBuildsBlock.vue?vue&type=template&id=af767322&ts=true"
import script from "./PersonalBuildsBlock.vue?vue&type=script&lang=ts"
export * from "./PersonalBuildsBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__